// extracted by css-extract-rspack-plugin
module.exports =  {"root":"fce3378472","message":"b796ac3d03"};